import classNames from 'classnames'
import style from './ContentWrapper.module.scss'

const ContentWrapper = ({ children, className }) => {
  return <div className={classNames(style.wrapper, style[className])}>{children}</div>
}

export default ContentWrapper
